import React from 'react';

import { InputAdornment, Typography } from '@material-ui/core';

import { TextField, Step } from '../SteppedForm';

import rules from './rules';

const StepM7details = (props) => {
  return (
    <Step
      id="m7details"
      title="Operator Account Number"
      skip={(formdata) => formdata.onboardingFor === 'operator'}>
      <Typography variant="body1" class="formQuestion">
        What is your Operator Account number?
      </Typography>
      <TextField
        id="m7_account"
        label="Operator Account Number"
        valid={rules.accountNumber(5)}
        modify={(value) => props.limitLength(value, 5)}
        InputProps={{
          startAdornment: <InputAdornment position="start">A</InputAdornment>
        }}
        required
      />
    </Step>
  );
};

export default StepM7details;
